import { render } from "./App.vue?vue&type=template&id=27b4432f&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=27b4432f&lang=css&scoped=true"
import "./App.vue?vue&type=style&index=1&id=27b4432f&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b4432f"]])

export default __exports__